<template>
  <div id="app" class="wrapper">
    <notifications group="foo" />
    <router-view/>
	<modal-back-drop-component v-if="isVisibleModal" />
  </div>
</template>

<script>
import refreshToken from "./mixins/refreshTokenMixin";
import twoFAMixin from './mixins/twoFAMixin';
import ModalBackDropComponent from "./components/ModalBackDropComponent";
import {auth, db, messaging} from "@/firebase/init";


export default {
  name: "app",
  components: {ModalBackDropComponent},
  mixins:[refreshToken, twoFAMixin],
  data () {
    return {
      testAccounts: ['salman.yousaf47@gmail.com', 'salman.yousaf047@gmail.com', 'salman.yousaf@septemsystems.com']
    }
  },
  computed: {
    isVisibleModal() {
        return this.$store.getters.isVisibleModal;
    },
      notificationListener(){
          return this.$store.getters['notification/getNotificationListener'];
      },
      accountListener(){
          return this.$store.getters['hosting/accountListener'];
      },
    user(){
      return this.$store.getters.user;
    },

  },
  created() {
    this.refreshToken();
    setInterval(()=>{
        this.refreshToken();
    }, 300 * 1000);
      const userDtls = JSON.parse(localStorage.getItem("userDtls"));

    if(this.$cookie.get('login-session') === null){
        if(auth.currentUser){
            this.logout();
        }
    }else{
        if (userDtls !== null) {
            this.$store.dispatch("updateUserDetails", userDtls);
        }
    }
  },
    methods:{
       async removeFcmToken(){
         try{
           const token = await messaging.getToken()
           if (this.user && this.user.uid) {
             const ref = await db.collection('users').doc(this.user.uid).get();
             let {fcmToken} = ref.data()
             if(Array.isArray(fcmToken)){
               if(fcmToken.includes(token)) {
                 const indexToRemove = fcmToken.indexOf(token);
                 if (indexToRemove !== -1) {
                   fcmToken.splice(indexToRemove, 1);
                 }
               }
             }
             else if(fcmToken === token){
               fcmToken= [];
             }
             console.log('tokens', fcmToken)
             await db.collection('users').doc(this.user.uid).update({
               fcmToken: [...fcmToken]
             });
           }
         }
         catch(e){
           console.log(e)
         }
       },
        async logout() {
         try {

           await this.removeFcmToken()
         } catch (e) {
           console.log('something went wrong while removing token', e.toString())
         }
            await this.updateTwoFAVerified(false);
            this.$store.commit('updateShowNotificationOnLogIn', true);
            if(this.notificationListener){
                console.log('detach notification listener');
                this.notificationListener();
            }
            if(this.accountListener){
                console.log('detach account listener');
                this.accountListener();
            }
            this.$store.dispatch('notification/resetAdminListens');
            auth.signOut().then(async () => {
                this.$cookie.delete('rememberComputer');
                this.$cookie.delete('defaultLogin');
                localStorage.removeItem("userDtls");
                localStorage.removeItem('adminToken');
                localStorage.removeItem('adminDtls');
                localStorage.removeItem('accounts');
                localStorage.removeItem('customers');
                window.location = '/'
            });
        },
    }
};
</script>


<style lang="scss">
// Import Paper Dashboard CSS file globally
@import "./assets/scss/paper-dashboard.scss";

:focus {
  outline: none;
}

.wrapper {
  background-color: #f3f2ee;
}

hr {
  &.color-line {
    background: url("./assets/img/seperator.png") left top repeat-x;
    background-size: 45px 5px;
    height: 5px;
    border: none;
  }
}

.border-bottom-color-line {
  border-bottom: 5px solid;
  border-image: url("./assets/img/seperator.png") 10 1 round;
}

.round-border {
  border-radius: 10px;
}

.text-red {
  color: #dc3545;
  opacity: 0.8;

  &:hover {
    color: #dc3545;
    opacity: 1;
    transition: all 0.3s;
  }
}

.center {
  margin-left: auto !important;
  margin-right: auto !important;
  display: table !important;
}

.big-badge {
  font-size: 12px;
  padding: 6px 10px;
}

.bg-violate {
  background-color: #8e44ad;
  &:hover,
  &:active,
  &:focus {
    background-color: #a94ad1 !important;
  }
}
.text-violate {
  color: #8e44ad;
}
.bg-yellow {
  background-color: #f5cd79;
  color: #303952;
  &:hover,
  &:active,
  &:focus {
    background-color: #f7d794 !important;
    color: #596275 !important;
  }
}
.bg-peach {
  background-color: #f19066;
  // color: #303952;
  &:hover,
  &:active,
  &:focus {
    background-color: #f3a683 !important;
    // color: #596275 !important;
  }
}
.bg-midnight-blue {
  background-color: #2c3e50;
  &:hover,
  &:active,
  &:focus {
    background-color: #4c7cac !important;
  }
}
.bg-orange {
  background-color: #e15f41;
  &:hover,
  &:active,
  &:focus {
    background-color: #e77f67 !important;
  }
}
.bg-teal {
  background-color: #009688;
  &:hover,
  &:active,
  &:focus {
    background-color: #04645b !important;
  }
}

.swal2-popup .swal2-content {
  color: #000000;
  font-weight: 400;
}

.bootstrap-select {
	.dropdown-menu {
		li {
			&.active {
				a {
					color: #ffffff;
				}
			}
		}
	}
	.dropdown-toggle {
		background: transparent;
		color: #64615E;
		border: 1px solid #DCDCDC;
		margin: 0;

		&:hover,
		&:active,
		&:focus {
			background: transparent !important;
			color: #64615E !important;
			border: 1px solid #DCDCDC !important;
		}

		.filter-option {
			font-weight: normal;
		}
	}
}

.dropdown-item {
	&.active {
		background-color: #5C7CF9 !important;
	}
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
	width: 100%;
}
/*
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #5a7cfd;
  border-right: 16px solid #30cb87;
  border-bottom: 16px solid #dc3545;
  border-left: 16px solid #fecd47;
  margin: 2rem auto 2rem auto;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
*/
.loader {
	position: relative;
	margin: 2rem auto 2rem auto;
	width: 120px;
	height: 120px;
	background-image: url("./assets/img/preload.gif");
	background-size: cover;
	&.small_loader{
		margin: 0 auto;
		width: 40px;
		height: 40px;
	}
	&.mini_loader{
		margin: 0 auto;
		width: 15px;
		height: 15px;
	}
}

</style>
